import React from 'react';
import css from './Sections.module.css';
import { PrimaryButton } from '../../../components';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { createResourceLocatorString } from '../../../util/routes';
import routeConfiguration from '../../../routing/routeConfiguration';

function VisitSupplierSection() {
  const history = useHistory();
  const redirectToTrustedSuppliers = () => {
    history.push(createResourceLocatorString('TrustedSuppliersPage', routeConfiguration(), {}, {}));
  };

  return (
    <div className={css.trustedSupplierSection}>
      <div className={css.fixedWidthContainer}>
        <div className={css.trustedSupplierInfo}>
          <h2>Visit our Trusted Suppliers</h2>
          <p>
            Poor groundwork can cause delays, structural issues, and costly rework later in your
            project. Without experienced contractors, your build’s success is at risk from day one.
            Visit our Trusted Supplier page to find vetted groundworks professionals who deliver
            solid foundations, expert drainage, and precise site preparation—ensuring your project
            starts strong, stays compliant, and runs on time.
          </p>
          <PrimaryButton
            type="button"
            className={css.trustedSupplierBtn}
            onClick={redirectToTrustedSuppliers}
          >
            Visit Trusted Suppliers
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
}

export default VisitSupplierSection;
